import React, { useEffect, useState } from "react";
import { useUserQueries } from "../../hooks/useUsers.ts";
import Loader from "../../components/Loader.tsx";
import { FiEye } from "react-icons/fi";
import { useTheme } from "../../contexts/ThemeContext.tsx";
import { themes } from '../../theme.ts';

interface Query {
  id: number;
  description: string;
  status: string;
}

const MyQueries = () => {
  const { themeName } = useTheme();
  // const [queries, setQueries] = useState<Query[]>([]); // Replaced by hook
  // const [loading, setLoading] = useState(true); // Replaced by hook
  const [selectedQuery, setSelectedQuery] = useState<Query | null>(null);

  const userString = localStorage.getItem("user");
  const user = userString ? JSON.parse(userString) : null;

  const { data: queriesResponse, isLoading: loading } = useUserQueries(user?.user?.id);
  const queries = (queriesResponse as any)?.data || [];

  return (
    <div
      className="min-h-[80vh]"
      style={{ backgroundColor: themes[themeName].colors.background }}
    >
      {/* <h2 className="text-2xl font-bold text-teal-700 mb-4 text-center">My Queries</h2> */}

      {loading ? (
        <div className="flex justify-center items-center mt-6">
          <div
            className="loader border-t-4 rounded-full w-12 h-12 animate-spin"
            style={{ borderColor: themes[themeName].colors.primary }}
          ></div>
          <p
            className="ml-4"
            style={{ color: themes[themeName].colors.textSecondary }}
          >
            Loading ...
          </p>
        </div>
      ) : queries?.length > 0 ? (
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {queries.map((query, index) => (
            <div
              key={query.id}
              className="rounded-xl shadow-lg p-5 hover:shadow-xl transition-all"
              style={{
                backgroundColor: themes[themeName].colors.surface,
                borderColor: themes[themeName].colors.border,
                borderWidth: 1,
                borderStyle: 'solid'
              }}
              onMouseEnter={(e) => e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'}
              onMouseLeave={(e) => e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'}
            >
              <div className="mb-2">
                <p
                  className="text-sm mb-2 line-clamp-3"
                  style={{ color: themes[themeName].colors.text }}
                >
                  {query.description}
                </p>
              </div>
              <div className="flex items-center justify-between">
                <span
                  className="text-xs px-3 py-1 rounded-full font-medium"
                  style={{
                    backgroundColor:
                      query.status === "Resolved"
                        ? themes[themeName].colors.success + '33'
                        : query.status === "Pending"
                          ? themes[themeName].colors.warning + '33'
                          : themes[themeName].colors.error + '33',
                    color:
                      query.status === "Resolved"
                        ? themes[themeName].colors.success
                        : query.status === "Pending"
                          ? themes[themeName].colors.warning
                          : themes[themeName].colors.error,
                  }}
                >
                  {query.status}
                </span>
                <button
                  onClick={() => setSelectedQuery(query)}
                  className="flex items-center gap-1 text-sm font-semibold transition-colors"
                  style={{ color: themes[themeName].colors.primary }}
                  onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
                  onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
                >
                  <FiEye className="text-base" />
                  View
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p
          className="text-center mt-10"
          style={{ color: themes[themeName].colors.textSecondary }}
        >
          No queries found.
        </p>
      )}

      {/* MODAL */}
      {selectedQuery && (
        <div
          className="fixed inset-0 flex justify-center items-center z-[991] px-4"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)' }}
        >
          <div
            className="max-h-[90vh] overflow-y-scroll max-w-md w-full rounded-lg shadow-lg p-6 relative animate-fade-in-up"
            style={{
              backgroundColor: themes[themeName].colors.surface,
              borderColor: themes[themeName].colors.border,
              borderWidth: 1,
              borderStyle: 'solid'
            }}
          >
            <button
              className="absolute top-2 right-3 text-xl"
              style={{ color: themes[themeName].colors.textSecondary }}
              onClick={() => setSelectedQuery(null)}
              onMouseEnter={(e) => e.currentTarget.style.color = themes[themeName].colors.text}
              onMouseLeave={(e) => e.currentTarget.style.color = themes[themeName].colors.textSecondary}
            >
              ×
            </button>
            <h3
              className="text-lg font-bold mb-3"
              style={{ color: themes[themeName].colors.primary }}
            >
              Query Details
            </h3>
            <p
              className="mb-4 whitespace-pre-wrap"
              style={{ color: themes[themeName].colors.text }}
            >
              {selectedQuery.description}
            </p>
            <p className="text-sm">
              <span style={{ color: themes[themeName].colors.textSecondary }}>
                Status:{" "}
              </span>
              <span
                className="font-semibold"
                style={{ color: themes[themeName].colors.primary }}
              >
                {selectedQuery.status}
              </span>
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyQueries;
